import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=5dd15ee9&"
import script from "./TabMenu.vue?vue&type=script&lang=ts&"
export * from "./TabMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports